import Nurses from './Nurses'
export default Nurses